export default __webpack_public_path__ + "static/media/logo.157a2f7a.png";